import React from 'react'

type Props = {}

const useStyleDashboardPage = (props: Props) => {

  const cardStyle = {
    borderRadius: '1.5rem',
    padding: { xs: 1, sm: 4 },
    py: { xs: 3, md: 4 },
    border: 'unset',
    boxSizing: 'border-box',
  }

  return {
    main: {
      backgroundColor: '#F4F7FF',
      padding: { xs: 1, md: 4 },
      pt: { xs: 3, md: 4 },
      boxSizing: 'border-box',
    },
    content: {
      // gap: { xs: 1, md: 4 },
      pb: 10,
      boxSizing: 'border-box',
      height: 'fit-content',
      display: 'grid',
      gridTemplateColumns: '1.5fr 1fr',
      gridTemplateAreas: '"_header _header" "_quota _quota" "_exam _exam" "_calendar _calendar"',
      width: 'fit-content',
      maxWidth: '1200px',
      margin: 'auto'
    },
    header: {
      gridArea: '_header',
    },
    performance: {
      gridArea: '_performance',
    },
    quotaCard: {
      gridArea: '_quota',
      ...cardStyle,
    },
    upcomingExam: {
      mt: { xs: 1, md: 4 },
      gridArea: '_exam',
      ...cardStyle,
    },
    calendar: {
      mt: { xs: 1, md: 4 },
      gridArea: '_calendar',
      ...cardStyle,
    }
  }
}

export default useStyleDashboardPage
